/**
 * Qué conexión de LinkedIn se está armando (card fqyBbFvp): el id de la conexión a reconectar, el
 * nombre que va a llevar y la cuenta publicitaria a re-asignar. El callback `/connect-linkedin` la lee
 * y la manda al backend.
 *
 * Vive en sessionStorage, caduca a los 15 minutos y se consume al leerla (mismo patrón que
 * `onboarding/oauthReturn.js`). **Toda entrada al OAuth de LinkedIn la ESCRIBE ENTERA** —también las
 * de conexión nueva, sin id ni nombre—, así un OAuth abandonado nunca deja nada que la próxima
 * conexión herede. Antes el nombre iba a localStorage sin vencimiento: una reconexión abandonada
 * seguida de una conexión nueva sin nombre mandaba el nombre viejo, y el backend (que matchea por
 * nombre) le escribía el token de la persona nueva a la conexión vieja (QA-linkedin-07 y R-linkedin-01).
 */

const KEY = 'pending_linkedin_reconnect';
const MAX_AGE_MS = 15 * 60 * 1000;

/**
 * Anota la conexión de LinkedIn que está por arrancar. Todos los campos son opcionales: sin `id` es
 * una conexión nueva; sin `label` el backend usa el nombre por default.
 */
export function setPendingLinkedinConnection({id = null, label = null, adAccountId = null} = {}) {
    try {
        window.sessionStorage.setItem(KEY, JSON.stringify({
            id: id != null ? String(id) : null,
            label: label ? String(label) : null,
            adAccountId: adAccountId != null ? String(adAccountId) : null,
            at: Date.now(),
        }));
    } catch (error) {
        // Sin sessionStorage la conexión sale sin nombre ni reconexión: el backend matchea por el
        // nombre por default, como antes.
    }
}

/** Reconectar ESTA conexión (botón «Reconectar» de Conexiones). */
export function setPendingLinkedinReconnect(credentialId, label = null) {
    setPendingLinkedinConnection({id: credentialId, label});
}

export function clearPendingLinkedinReconnect() {
    try {
        window.sessionStorage.removeItem(KEY);
    } catch (error) {
        // Nada que limpiar.
    }
}

/**
 * La nota completa `{id, label, adAccountId}` si sigue vigente, o null. La borra siempre: usada o
 * vencida, no sobrevive a esta lectura.
 */
export function consumePendingLinkedinConnection() {
    let note = null;
    try {
        note = JSON.parse(window.sessionStorage.getItem(KEY));
    } catch (error) {
        note = null;
    }
    clearPendingLinkedinReconnect();
    if (!note || typeof note.at !== 'number' || Date.now() - note.at > MAX_AGE_MS) {
        return null;
    }
    return {id: note.id || null, label: note.label || null, adAccountId: note.adAccountId || null};
}

/** Sólo el id de la conexión a reconectar (o null). Consume la nota. */
export function consumePendingLinkedinReconnect() {
    const note = consumePendingLinkedinConnection();
    return note ? note.id : null;
}
